import React from "react"
import { NavLink } from "react-router-dom"
import propTypes from "prop-types"

const UserDropMenu = ({ navigation, isOpen, onSupportTeam, onSignOut }) => {
  return (
    <ul
      className={[
        "user-menu_drop-menu",
        isOpen ? "user-menu_drop-menu--show" : ""
      ].join(" ")}
    >
      {navigation.map(item => {
        let el

        if (item.action === "supportTeam") {
          el = (
            <li key={item.id}>
              <button onClick={onSupportTeam} type="button">
                {item.title}
              </button>
            </li>
          )
        } else {
          el = (
            <li key={item.id}>
              <NavLink exact to={item.href} activeClassName="user-menu--active">
                {item.title}
              </NavLink>
            </li>
          )
        }

        return el
      })}
      <li>
        <button onClick={onSignOut} type="button">
          Sign Out
        </button>
      </li>
    </ul>
  )
}

UserDropMenu.defaultProps = {
  onSupportTeam: () => {}
}

UserDropMenu.propTypes = {
  navigation: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.number,
      href: propTypes.string,
      title: propTypes.string
    })
  ).isRequired,
  isOpen: propTypes.bool.isRequired,
  onSupportTeam: propTypes.func,
  onSignOut: propTypes.func.isRequired
}

export default UserDropMenu
